import { LanguageString } from '../../common/components/dashboards/types';
import {
  CohortMetricIdType,
  DataFieldWithDataType,
  EmployeeCohortMetricIdType,
  RegularMetricIdType,
} from '../../types';
import { SQLFilters } from '../types';
import {
  GroupingInput,
  MetricCategoryId,
  MetricFormatTypeId,
  MetricGroupId,
  MetricId,
  MetricLifecycleStage,
  MetricType,
  QueryCohortMetricsQuery,
  QueryEmployeeCohortMetricsQuery,
  QueryMetricsQuery,
  TimeSelectionInput,
} from '../types-graphql';

// We use this for raw html strings. The content should be parsed as (safe) HTML and then presented in that way.
export type HtmlString = string;

export interface QueryRegularMetricsParams {
  timeSelection: TimeSelectionInput;
  metrics: RegularMetricIdType[];
  userFilters?: SQLFilters;
  grouping?: GroupingInput;
  disableNestLoop?: boolean;
}

export interface QueryCohortMetricsParams {
  timeSelection: TimeSelectionInput;
  metrics: CohortMetricIdType[];
  userCohortFilters?: SQLFilters;
  grouping?: GroupingInput;
  disableNestLoop?: boolean;
}

export interface QueryEmployeeCohortMetricsParams {
  timeSelection: TimeSelectionInput;
  metrics: EmployeeCohortMetricIdType[];
  userCohortFilters?: SQLFilters;
  userFilters?: SQLFilters;
  grouping?: GroupingInput;
  disableNestLoop?: boolean;
}

export type RegularMetricQueryService = (
  params: QueryRegularMetricsParams
) => Promise<QueryMetricsQuery>;
export type CohortMetricQueryService = (
  params: QueryCohortMetricsParams
) => Promise<QueryCohortMetricsQuery>;
export type EmployeeCohortMetricQueryService = (
  params: QueryEmployeeCohortMetricsParams
) => Promise<QueryEmployeeCohortMetricsQuery>;

export enum MetricLifecycleStageEnum {
  MetricLifecycleStageActive = 'MetricLifecycleStageActive',
  MetricLifecycleStageDeprecated = 'MetricLifecycleStageDeprecated',
  MetricLifecycleStageDevelopment = 'MetricLifecycleStageDevelopment',
  MetricLifecycleStageDisabled = 'MetricLifecycleStageDisabled',
}

export interface MetricDetails {
  id: MetricId;
  metricName: LanguageString;
  metricGroupId: MetricGroupId;
  metricType: MetricType;
  formatType: MetricFormatTypeId;
  underlyingFields: DataFieldWithDataType[] | null;
  defaultPosition: number;
  segmentationPercAllowed: boolean;
  lifecycleStage: MetricLifecycleStage;
  tooltipJapanese?: HtmlString | null;
  tooltipEnglish?: HtmlString | null;
}

export interface MetricGroupDetails {
  id: MetricGroupId;
  metricGroupName: LanguageString;
  defaultCategory: MetricCategoryId;
  dimensions: MetricDetails[];
  defaultPosition: number;
  defaultCategoryPosition: number;
}

export interface MetricCategoryDetails {
  id: MetricCategoryId;
  metricCategoryName: LanguageString;
  defaultPosition: number;
}

export type MetricTree = {
  groupDetails: MetricGroupDetails[];
  categoryDetails: MetricCategoryDetails[];
};
